import type { BrooklynPlans, TPlan } from '~/src/common/brooklyn/plans';

export function getMonthlyPlan(plans: BrooklynPlans): TPlan | null {
  return plans?.basic ?? null;
}
